


// Get Settings
export const getSettingsStart =()=>({
    type: "GET_SETTINGS_START",
});
export const getSettingsSuccess =(settings)=>({
    type: "GET_SETTINGS_SUCCESS",
    payload: settings,
});
export const getSettingsFailure =(error)=>({
    type: "GET_SETTINGS_FAILURE",
    payload: error,
});

// Update Settings
export const updateSettingsStart =()=>({
    type: "UPDATE_SETTINGS_START",
});
export const updateSettingsSuccess =(settings)=>({
    type: "UPDATE_SETTINGS_SUCCESS",
    payload: settings,
});
export const updateSettingsFailure =(error)=>({
    type: "UPDATE_SETTINGS_FAILURE",
    payload: error,
});